import React from "react";

import "./style.less";

const ImageFile = ({ url }) => <img className="driverDocumentPreview" src={url} alt={url} />;

export default ImageFile;
